// these sizes are arbitrary and you can set them to whatever you wish
import { css } from 'styled-components'




function _mediaCss (size){
  // use em in breakpoints to work properly cross-browser and support users
  // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
  const emSize = size / 16
 return (...args) => css`
    @media (min-width: ${emSize}em) {
      ${css(...args)}
    }
  `

}

const sizes = {
  tablet: 768,
  desktop: 992,
  standardDesktop: 1368,
  giant: 1200
}


export const media ={
  tablet:_mediaCss(sizes.tablet),
  desktop:_mediaCss(sizes.desktop),
  standardDesktop:_mediaCss(sizes.standardDesktop),
  giant:_mediaCss(sizes.giant),
}


export const mediaCode = Object.keys(sizes).reduce((accumulator, label) => {
  const emSize = sizes[label] / 16
  accumulator[label] = (...args) => `
    @media (min-width: ${emSize}em) {
      ${css(...args)}
    }
  `
  return accumulator
}, {})


